import * as types from "./actionTypes";

export const creatingUserInProfile = (userData, shouldOnboard = true) => ({
  type: types.CREATING_USER_IN_PROFILE,
  userData,
  shouldOnboard,
});

export const updateUserInProfile = (userRef, userData, route) => ({
  type: types.UPDATE_USER_IN_PROFILE,
  userRef,
  userData,
  route,
});

export const updateUserInProfileSilent = (userRef, userData, onboarding) => ({
  type: types.UPDATE_USER_IN_PROFILE_SILENT,
  userRef,
  userData,
  onboarding,
});

export const updateGeneralConsent = () => ({
  type: types.UPDATE_GENERAL_CONSENT,
});

export const updateCvInProfileSilent = (userRef, userData, onboarding) => ({
  type: types.UPDATE_CV_SILENT,
  userRef,
  userData,
  onboarding,
});

export const resendConfirmation = () => ({
  type: types.USER_RESEND_CONFIRMATION,
});

export const getUserInProfile = () => ({
  type: types.GET_USER_IN_PROFILE,
});

export const storeUserData = (userData) => ({
  type: types.STORE_USER_DATA_IN_APP,
  payload: userData,
});

export const userSetIsLoading = (isLoading, userFlow) => ({
  type: types.USER_SET_IS_LOADING,
  payload: { isLoading, userFlow },
});

export const setCvUploadLoading = (isCvLoading) => ({
  type: types.SET_CV_IS_LOADING,
  payload: isCvLoading,
});

export const setError = (error) => ({
  type: types.SET_ERROR,
  payload: error,
});

export const setPendingConfirmation = (isPendingConfirmation) => ({
  type: types.USER_SET_PENDING_CONFIRMATION,
  payload: isPendingConfirmation,
});

export const setHasLinkedProfileAccount = () => ({
  type: types.HAS_LINKED_PROFILE_ACCOUNT,
  payload: true,
});

export const checkHasLinkedProfileAccount = () => ({
  type: types.CHECK_HAS_LINKED_PROFILE_ACCOUNT,
});

export const continueRegistration = () => ({
  type: types.CONTINUE_REGISTRATION,
});

export const setContinuingRegistration = (isContinuing) => ({
  type: types.SET_CONTINUING_REGISTRATION,
  payload: isContinuing,
});

export const setCvProgress = (progress) => ({
  type: types.CV_PROGRESS,
  payload: progress,
});

export const submitClientFormSilent = (formContent) => ({
  type: types.SUBMIT_CLIENT_FORM_SILENT,
  payload: { formContent },
});
